import { Icon } from "@iconify/react";
import IMAGES from "constants/images";
import React, { useState, useEffect } from "react";
import { Col, Container, Image, ListGroup, Row, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

import { fetchCategoryProducts } from "api/ProductService";
import { useAuth } from "context/UserContext";
import StepOneComponent from "./step1";
import StepTwoComponent from "./step2";
import StepFourComponent from "./step4";
import StepThreeComponent from "./step3";
import useDebounce from "hooks/useDebounce";
import { useUserRole } from "services/provider";
import Modals from "inc/Modals";
import { toast } from "react-toastify";

const WriteAReview = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const reviewId = location?.state?.reviewId || "";
  const [step, setStep] = useState(() => {
    const saved = localStorage.getItem("step");
    if (!saved) {
      localStorage.setItem("step", "1");
      return 1;
    }
    try {
      const parsedStep = JSON.parse(saved);
      if (!parsedStep) {
        localStorage.setItem("step", "1");
        return 1;
      }
      return parsedStep;
    } catch (err) {
      localStorage.setItem("step", "1");
      return 1;
    }
  });

  const [searchText, setSearchText] = useState("");
  const debouncedSearch = useDebounce(searchText, 500);

  const [checkedProducts, setCheckedProducts] = useState(() => {
    const saved = localStorage.getItem("checkedProducts");
    try {
      return saved ? JSON.parse(saved) : [];
    } catch (err) {
      console.error("Invalid checkedProducts in localStorage", err);
      localStorage.setItem("checkedProducts", JSON.stringify([]));
      return [];
    }
  });
  const [productLoading, setProductLoading] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const limit = 10;
  const { isLoggedIn, user } = useAuth();
  const userId = user ? user._id : "";
  const [modalType, setModalType] = useState(isLoggedIn ? "" : "login");
  const { role } = useUserRole();
  const [selectedSoftware, setSelectedSoftware] = useState({
    label: "All Reviews",
    value: "all",
  });

  useEffect(() => {
    if (user && user.role === "vendor") {
      navigate("/");
    }
    if(reviewId){
      setShowSidebar(false);
      setStep(3);
    }
  }, [user, navigate,reviewId]);

  const productId =
    checkedProducts.length > 0
      ? checkedProducts[0]?.id || checkedProducts[0]?._id
      : "";

  const productName =
    checkedProducts.length > 0
      ? checkedProducts[0]?.name || checkedProducts[0]?.title
      : "";

  // Sync checkedProducts with localStorage
  useEffect(() => {
    localStorage.setItem("checkedProducts", JSON.stringify(checkedProducts));
  }, [checkedProducts]);

  // Sync step with localStorage
  useEffect(() => {
    localStorage.setItem("step", JSON.stringify(step));
  }, [step]);

  // console.log("productId", productId);

  const handleNext = () => {
    if (step < steps.length) {
      setStep(step + 1);
      window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top smoothly
    }
  };

  // const initialProducts = [
  //   {
  //     id: 1,
  //     name: "monday Work Management",
  //     icon: IMAGES.Logo1,
  //     bgColor: "#FFDDE2",
  //     reviews: 2306,
  //     rating: 4.5,
  //     checked: false,
  //   },
  //   {
  //     id: 2,
  //     name: "Smartsheet",
  //     icon: IMAGES.Logo2,
  //     bgColor: "#DEFCF8",
  //     reviews: 1852,
  //     rating: 4.2,
  //     checked: false,
  //   },
  //   {
  //     id: 3,
  //     name: "Notion",
  //     icon: IMAGES.Logo3,
  //     bgColor: "#FFF7D7",
  //     reviews: 3124,
  //     rating: 4.7,
  //     checked: false,
  //   },
  //   {
  //     id: 4,
  //     name: "Asana",
  //     icon: IMAGES.Logo4,
  //     bgColor: "#E8F4FF",
  //     reviews: 2845,
  //     rating: 4.4,
  //     checked: false,
  //   },
  //   {
  //     id: 5,
  //     name: "Trello",
  //     icon: IMAGES.Logo5,
  //     bgColor: "#F0E8FF",
  //     reviews: 2156,
  //     rating: 4.3,
  //     checked: false,
  //   },
  //   {
  //     id: 6,
  //     name: "Jira",
  //     icon: IMAGES.Logo6,
  //     bgColor: "#FFE8E8",
  //     reviews: 2967,
  //     rating: 4.6,
  //     checked: false,
  //   },
  // ];
  const fetchProducts = async () => {
    try {
      setProductLoading(true);
      const catId =
        selectedSoftware.value === "all" ? "" : selectedSoftware.value;
      const res = await fetchCategoryProducts({
        search: debouncedSearch,
        catId,
        userId: "",
        page,
        limit,
      });
      if (res.success) {
        // setProducts(res.body.data); // set current page data only
        setSelectedProducts(res.body.data);
        setTotalItems(res.body.total); // total number of items
      }
      setProductLoading(false);
    } catch (err) {
      setProductLoading(false);
      console.error("Failed to fetch category products", err);
    }
  };
  useEffect(() => {
    fetchProducts();
  }, [page, debouncedSearch, selectedSoftware]);
  // console.log('step', step)
  const handleRemoveCheckedProduct = (productId) => {
    setCheckedProducts((prevChecked) => {
      const updatedChecked = prevChecked.filter(
        (product) => product.id !== productId
      );
      return updatedChecked;
    });

    // Optional: also uncheck in selectedProducts
    setSelectedProducts((prev) =>
      prev.map((product) =>
        product.id === productId ? { ...product, checked: false } : product
      )
    );
  };

  // Function to toggle checkbox
  const handleSelect = (productId) => {
    const updated = selectedProducts?.map((product) => {
      if (product.id === productId) {
        return { ...product, checked: !product.checked };
      }
      return { ...product, checked: false };
    });

    setSelectedProducts(updated);

    const checked = updated.find((product) => product.checked);
    const checkedList = checked ? [checked] : [];

    setCheckedProducts(checkedList);
  };

  const steps = [
    {
      id: 1,
      title: "Select Software and Services",
      component: (
        <StepOneComponent
          productLoading={productLoading}
          selectedProducts={selectedProducts}
          selectedSoftware={selectedSoftware}
          setSelectedSoftware={setSelectedSoftware}
          handleSelect={handleSelect}
          step={step}
          checkedProducts={checkedProducts}
          handleNext={handleNext}
          setSearchText={setSearchText}
          searchText={searchText}
          setCheckedProducts={setCheckedProducts}
          handleRemoveCheckedProduct={handleRemoveCheckedProduct}
        />
      ),
    },
    {
      id: 2,
      title: "Verify Your Identity",
      component: (
        <StepTwoComponent
          checkedProducts={checkedProducts}
          setStep={setStep}
          userId={userId}
          productId={productId}
          handleNext={handleNext}
          setCheckedProducts={setCheckedProducts}
        />
      ),
    },
    {
      id: 3,
      title: "Leave a Review",
      component: (
        <StepThreeComponent
          handleNext={handleNext}
          step={step}
          userId={userId}
          productId={productId}
          productName={productName}
        />
      ),
    },
    {
      id: 4,
      title: "Finished",
      component: <StepFourComponent setStep={setStep} />,
    },
  ];

  // useEffect(() => {
  //   const savedStep = localStorage.getItem("step");
  //   const savedChecked = localStorage.getItem("checkedProducts");

  //   if (savedStep) setStep(JSON.parse(savedStep));
  //   if (savedChecked) setCheckedProducts(JSON.parse(savedChecked));

  //   // Optional: clean it up so it doesn't linger forever
  //   // localStorage.removeItem("step");
  //   // localStorage.removeItem("checkedProducts");
  // }, []);

  // Check localStorage values periodically
  useEffect(() => {
    const checkLocalStorage = () => {
      // Check step
      const currentStep = localStorage.getItem("step");
      if (!currentStep) {
        localStorage.setItem("step", "1");
        setStep(1);
      }

      // Check checkedProducts
      const currentCheckedProducts = localStorage.getItem("checkedProducts");
      if (!currentCheckedProducts) {
        localStorage.setItem("checkedProducts", JSON.stringify([]));
        setCheckedProducts([]);
      } else {
        try {
          const parsed = JSON.parse(currentCheckedProducts);
          if (!Array.isArray(parsed)) {
            localStorage.setItem("checkedProducts", JSON.stringify([]));
            setCheckedProducts([]);
          } else {
            setCheckedProducts(parsed);
          }
        } catch (err) {
          localStorage.setItem("checkedProducts", JSON.stringify([]));
          setCheckedProducts([]);
        }
      }
    };

    // Check immediately on mount
    checkLocalStorage();

    // Then check periodically
    const interval = setInterval(checkLocalStorage, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <React.Fragment>
      <section className="write_sidebar pt-4 pb-5">
        <Container>
          <Row className="mb-4">
            <Col lg={12}>
              <Row>
                {/* Sidebar */}
                <Col
                  md={5}
                  lg={4}
                  className={`${showSidebar ? "show_mobile show_tab" : "d-none"}`}
                >
                  <div className="write_sidebar_list w-100">
                    <h5 className="write_h5">
                      Write your review following <br /> these simple steps.
                    </h5>
                    <ListGroup>
                      {steps.map((item) => (
                        <ListGroup.Item
                          key={item.id}
                          action
                          disabled={item.id > step}
                          onClick={() => {
                            console.log('item', item)
                            if(item.id===2 && !reviewId){
                              const checkedProducts = localStorage.getItem("checkedProducts");
                              if(!checkedProducts || JSON.parse(checkedProducts).length === 0){
                                toast.error("Please select a product first");
                                return;
                              }
                            }
                            if(item.id===3 && !reviewId){
                              const verificationId = localStorage.getItem("verificationId");
                              if(!verificationId){
                                toast.error("Please verify your identity first");
                                return;
                              }
                            }
                            setStep(item.id);
                            setShowSidebar(false);
                          }}
                          className={`d-flex justify-content-between align-items-center 
                          ${step === item.id ? "active" : ""}`}
                        >
                          {item.title}
                          {item.id < step ? (
                            <Image
                              src={IMAGES.CheckCircle_Img}
                              alt="Completed Step"
                              className="iconWidth"
                            />
                          ) : item.id === step ? (
                            <Image
                              src={IMAGES.RightArrow_Img}
                              alt="Current Step"
                              className="iconWidth"
                            />
                          ) : null}
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </div>
                </Col>
                <Col
                  md={5}
                  lg={4}
                 className="show_laptop"
                >
                  <div className="write_sidebar_list  " >
                    <h5 className="write_h5">
                      Write your review following <br /> these simple steps.
                    </h5>
                    <ListGroup>
                      {steps.map((item) => (
                        <ListGroup.Item
                          key={item.id}
                          action
                      
                          className={`d-flex justify-content-between align-items-center 
                          ${step === item.id ? "active" : ""}`}
                        >
                          {item.title}
                          {item.id < step ? (
                            <Image
                              src={IMAGES.CheckCircle_Img}
                              alt="Completed Step"
                              className="iconWidth"
                            />
                          ) : item.id === step ? (
                            <Image
                              src={IMAGES.RightArrow_Img}
                              alt="Current Step"
                              className="iconWidth"
                            />
                          ) : null}
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </div>
                </Col>

                {/* Content Area */}
            
                  <Col md={7} lg={8} className="">
                    <div className="review_content">
                      {!showSidebar && step !== 4 && (
                        <div className="profile_details_style  mb-3  d-flex  justify-content-between ">
                          <div className="d-flex align-items-center">
                            <Icon
                              icon="mdi:arrow-left"
                              style={{ fontSize: "24px" }}
                              className="me-4"
                              onClick={() =>{
                                if(reviewId){
                                  navigate(-1);
                                }else{
                                  console.log('checkedProducts', checkedProducts)
                                  if(checkedProducts.length===0){
                                    navigate(-1);
                                  }else{
                                    setShowSidebar(true);
                                  }
                                }
                              }}
                            />
                            <h3 className="mb-0"></h3>
                          </div>
                        </div>
                      )}
                      {steps.find((s) => s.id === step)?.component}
                    </div>

                    <div className="d-flex justify-content-between mt-4">
           

                      {step === steps.length && (
                        <div className="text-center w-100">
                          <Button
                            variant="info"
                            onClick={() => {
                              localStorage.removeItem("step");
                              localStorage.removeItem("checkedProducts");
                              localStorage.removeItem("verificationId");
                              navigate("/");
                            }}
                            className="border-radius-100 px-5"
                          >
                            Go To Home
                          </Button>
                        </div>
                      )}
                    </div>
                  </Col>

                  {/* <Col md={7} lg={8} className="show_laptop">
                    <div className="review_content">
                      {!showSidebar && step !== 4 && (
                        <div className="profile_details_style  header_profile2  d-flex  justify-content-between ">
                          <div className="d-flex align-items-center">
                            <Icon
                              icon="mdi:arrow-left"
                              style={{ fontSize: "24px" }}
                              className="me-4"
                              onClick={() => setShowSidebar(true)}
                            />
                            <h3 className="mb-0"></h3>
                          </div>
                        </div>
                      )}
                      {steps.find((s) => s.id === step)?.component}
                    </div>

                    <div className="d-flex justify-content-between mt-4">
                    

                      {step === steps.length && (
                        <div className="text-center w-100">
                          <Button
                            variant="info"
                            onClick={() => {
                              localStorage.removeItem("step");
                              localStorage.removeItem("checkedProducts");
                              localStorage.removeItem("verificationId");
                              navigate("/");
                            }}
                            className="border-radius-100 px-5"
                          >
                            Go To Home
                          </Button>
                        </div>
                      )}
                    </div>
                  </Col> */}
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      <Modals
        modalType={modalType}
        navigateTo={"/write-a-review"}
        setModalType={setModalType}
        handleCloseModal={() => {
          setModalType("");
        }}
        {...{
          role,
          navigate,
        }}
      />
    </React.Fragment>
  );
};

export default WriteAReview;
